import { render, staticRenderFns } from "./SelectedTag.vue?vue&type=template&id=b02faa70&scoped=true&"
import script from "./SelectedTag.vue?vue&type=script&lang=js&"
export * from "./SelectedTag.vue?vue&type=script&lang=js&"
import style0 from "./SelectedTag.vue?vue&type=style&index=0&id=b02faa70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02faa70",
  null
  
)

export default component.exports